module.exports = __webpack_public_path__ + "static/media/transmitedIcon.d9acb942.svg";